import { render, staticRenderFns } from "./CognitiveCTMS.vue?vue&type=template&id=c4c9d9aa&scoped=true"
import script from "./CognitiveCTMS.vue?vue&type=script&lang=js"
export * from "./CognitiveCTMS.vue?vue&type=script&lang=js"
import style0 from "./CognitiveCTMS.vue?vue&type=style&index=0&id=c4c9d9aa&prod&scoped=true&lang=css"
import style1 from "./CognitiveCTMS.vue?vue&type=style&index=1&id=c4c9d9aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c9d9aa",
  null
  
)

export default component.exports